define(["exports", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components"], function (_exports, _objectWithoutPropertiesLoose2, _react, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.BoxShadow = void 0;
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  var _excluded = ["children"];
  var BoxShadowStyled = (0, _styledComponents.default)('div').withConfig({
    displayName: "BoxShadow__BoxShadowStyled",
    componentId: "sc-1jyky3j-0"
  })(["background-color:", ";border-radius:", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.3);width:100%;"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var rounded = _ref2.rounded;
    return rounded ? '2px' : '0';
  });

  var BoxShadow = function BoxShadow(_ref3) {
    var children = _ref3.children,
        props = (0, _objectWithoutPropertiesLoose2.default)(_ref3, _excluded);
    return /*#__PURE__*/_react.default.createElement(BoxShadowStyled, props, children);
  };

  _exports.BoxShadow = BoxShadow;
  BoxShadow.defaultProps = {
    rounded: true
  };
});